import { getCurrentDesign } from "@tSurya/theme/design";

function buildColors() {
    var design = getCurrentDesign();
    var C = design.COLORS;
    return {
        primary: {
            main: C.primary.base,
            contrast: C.primary.contrast,
        },
        secondary: {
            main: C.secondary.base,
            contrast: C.white,
        },
        accent: {
            main: C.accent.main,
            contrast: C.accent.contrast,
        },
        background: {
            main: C.background.main,
            contrast: C.background.contrast,
        },
        border: C.border.main,
        disabled: C.disabled.main,
        info: {
            main: C.info.main,
            contrast: C.info.contrast,
        },
        success: {
            main: C.success,
            contrast: C.white,
        },
        danger: {
            main: C.error,
            contrast: C.white,
        },
        warning: {
            main: C.warning,
            contrast: C.white,
        },
        text: {
            main: C.text.main,
            accent: C.text.accent,
            disabled: C.text.disabled,
            link: C.text.link,
        },
        common: {
            background: C.background.main,
            backgroundContrast: C.background.light,
            accent: C.background.lighter || C.background.light,
            accentContrast: C.text.main,
            border: C.border.main,
            disabled: C.disabled.main,
        },
    };
}

var colorsProxy = new Proxy({} as ReturnType<typeof buildColors>, {
    get: function(_target, prop) {
        return (buildColors() as any)[prop];
    },
    ownKeys: function() {
        return Object.keys(buildColors());
    },
    getOwnPropertyDescriptor: function(_target, prop) {
        var c = buildColors() as any;
        if (prop in c) {
            return { configurable: true, enumerable: true, writable: true, value: c[prop] };
        }
        return undefined;
    },
    has: function(_target, prop) {
        return prop in buildColors();
    }
});

export default colorsProxy;
